import React , { useState} from 'react'
import {  updateDoc , setDoc , collection, getFirestore, onSnapshot , docs, doc} from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';




function Deleted(targets , name) {
  const [showControls , setShowControls] = useState(false)
  const firebaseConfig = {
  apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
  authDomain: "to-do-list-app-7aa20.firebaseapp.com",
  projectId: "to-do-list-app-7aa20",
  storageBucket: "to-do-list-app-7aa20.appspot.com",
  messagingSenderId: "388979404562",
  appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
  };
  initializeApp(firebaseConfig)

  // init services
  const db = getFirestore()
  // collection Ref
  const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)
  
  const handleDontCancel = d => {
    console.log(d.progress , d.deleted)
    
    const docRef = doc(colRef , `${d.id}` )

    updateDoc(docRef , {
      inProgress : true ,
      deleted : false
    });
    Swal.fire({
      position: 'center',
      imageUrl: 'https://thumbs.gfycat.com/CoolForcefulBronco-size_restricted.gif',
      imageWidth: 400,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      showCloseButton : true
    })
  }
  return (
    <div className="notes deletedEle">
      <div className="container">
        <div className="content">
          <div className="top alert alert-danger">
            <h1>Cancelled Tasks</h1>
            {targets.targets.filter(f => f.deleted === true).length !== 0 && (
              <button className="controlSet" onClick={()=> setShowControls(!showControls)}>
                <img src="https://cdn-icons-png.flaticon.com/512/627/627495.png" alt="" title='control button' />
              </button>
            )}
          </div>
          {targets.targets.filter(f => f.deleted === true).length === 0 && 
            <div className="alerting unfinished">
              <div className="alert alert-secondary">
                <h3>No Task cancelled</h3>
                <img src="https://c.tenor.com/kDJMj35kKT8AAAAd/ahmed-helmy-be-happy.gif" alt="not deleted" />
              </div>
            </div>
          }
          <div className="bottom">
            {targets.targets.filter(f => f.deleted === true).map(p => (
              <div key={p.id} className="tab">
                <h3 dir='auto'>{p.Target}</h3>
                <p dir='auto'>{p.Description}</p>
                {showControls === true && (
                  <div className="options del-opt" >
                    <div className="cont">
                      <button onClick={() => handleDontCancel(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/5110/5110294.png" alt="in progress" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Deleted